import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthService } from './shared/services/auth.service';

import { HttpClientModule } from '@angular/common/http';

import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { VerifyEmailComponent } from './components/verify-email/verify-email.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ShaftInformationComponent } from './components/shaft-information/shaft-information.component';
import { CompanyComponent } from './components/shaft-information/company/company.component';
import { ProvinceComponent } from './components/shaft-information/province/province.component';
import { AreaComponent } from './components/shaft-information/area/area.component';
import { ShaftComponent } from './components/shaft-information/shaft/shaft.component';
import { InfoCaptureComponent } from './components/shaft-information/info-capture/info-capture.component';
import { ShaftRoleComponent } from './components/shaft-information/shaft-role/shaft-role.component';
import { SectionComponent } from './components/shaft-information/section/section.component';
import {FormsModule} from '@angular/forms';

@NgModule({
  declarations: [
    AppComponent,
    SignInComponent,
    ForgotPasswordComponent,
    VerifyEmailComponent,
    DashboardComponent,
    ShaftInformationComponent,
    CompanyComponent,
    ProvinceComponent,
    AreaComponent,
    ShaftComponent,
    InfoCaptureComponent,
    ShaftRoleComponent,
    SectionComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule, // imports firebase/firestore, only needed for database features
    AngularFireAuthModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule
  ],
  providers: [AuthService],
  bootstrap: [AppComponent]
})
export class AppModule { }
